import { Helmet } from "react-helmet-async";
import { useSiteConfig } from "../context/SiteConfigContext";

const SEO = ({ meta = {} }) => {
  const { siteConfig } = useSiteConfig();

  const defaultSEO = siteConfig?.defaultSEO || {};
  const siteName = siteConfig?.siteName || "";

  const finalMeta = {
    ...defaultSEO,
    ...meta,
  };

  const exactTitle = `${finalMeta.title} | ${siteName}`;
  return (
    <Helmet>
      <title>{exactTitle}</title>

      <meta name="description" content={finalMeta.description} />
      <meta name="keywords" content={finalMeta.keywords} />

      <meta property="og:title" content={exactTitle} />
      <meta property="og:description" content={finalMeta.description} />
      <meta property="og:image" content={finalMeta.image} />

      <meta name="twitter:card" content="summary_large_image" />

      <link rel="canonical" href={finalMeta.url || window.location.href} />
    </Helmet>
  );
};

export default SEO;
